// Refactor 02/2026 — extrahiert aus AppointmentsPage.js (Wochen-Ansicht).
import React from 'react';
import { Plus } from 'lucide-react';
import { toLocalYMD } from './calendarUtils';

export const WeekView = ({
  weekDays,
  timeSlots,
  appointmentCountsByIsoDate,
}) => (
  <div className="overflow-x-auto">
    <table className="w-full border-collapse">
      <thead>
        <tr className="bg-gray-50 border-b">
          <th className="p-3 text-left font-semibold text-sm sticky left-0 bg-gray-50 z-10 w-24">
            Zeit
          </th>
          {weekDays.map((day) => (
            <th
              key={day.toISOString()}
              className="p-3 text-center font-semibold text-sm border-l min-w-[150px]"
            >
              <div>
                {day.toLocaleDateString('de-DE', { weekday: 'short' })}
              </div>
              <div className="text-xs font-normal text-gray-500">
                {day.toLocaleDateString('de-DE', {
                  day: 'numeric',
                  month: 'numeric',
                })}
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {timeSlots.map((timeSlot) => (
          <tr key={timeSlot} className="border-b hover:bg-gray-50">
            <td className="p-2 text-sm font-medium text-gray-600 sticky left-0 bg-white border-r">
              {timeSlot}
            </td>
            {weekDays.map((day) => {
              const dayStr = toLocalYMD(day);
              const slotCount = appointmentCountsByIsoDate[dayStr] || 0;

              return (
                <td
                  key={`${day.toISOString()}-${timeSlot}`}
                  className="p-1 border-l cursor-pointer transition-colors bg-white hover:bg-teal-50"
                >
                  {slotCount > 0 ? (
                    <div className="text-xs text-teal-600 font-medium">
                      {slotCount}
                    </div>
                  ) : (
                    <div className="h-12 flex items-center justify-center text-gray-400">
                      <Plus size={14} />
                    </div>
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default WeekView;
